
export default {
    inheritAttrs: false,

    props: {
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
        hideCloseButton: {
            type: Boolean,
            default: false,
        },
        ctaTo: {
            type: String,
            default: '',
        },
        ctaLabel: {
            type: String,
            default: '',
        },
        contentClass: {
            type: String,
            default: '',
        },
        modalWidth: {
            type: String,
            default: 'lg:w-[600px]',
        },
        removePadding: {
            type: Boolean,
            default: false,
        },
        invertCloseButton: {
            type: Boolean,
            default: false,
        },
    },
}
